/**
 * @component {"type":"yesNoFeedbacks","version":"1.1"}
 */

define('task-yes-no-question',['knockout', 'helpers'], function(ko, helpers) {
    'use strict';

    return function(parentVM, dataContext) {
        var self = this,
            entityVM = parentVM.entity,
            trainingVM = parentVM.training;

        if (!dataContext.learning || !dataContext.learning.current) {
            return;
        }

        self.oddNo = ko.computed(function() {
            var computedQuestions = trainingVM.computedQuestions();

            return (Array.isArray(computedQuestions) & computedQuestions.length % 2 !== 0) ? true : false;
        });

        self.feedbacks = ko.computed(function() {
            var content = helpers.component.getContent(entityVM.componentsJSON(), 'yesNoFeedbacks');

            return helpers.component.parseProp(content, 'feedbacks', 'yesNoFeedbackItemOption');
        });

        self.enableFeedbacks = ko.computed(function() {
            var feedbacks = self.feedbacks(),
                claims = entityVM.questionsJS();

            if (feedbacks && feedbacks.length && feedbacks.length === claims.length) {
                return true;
            } else if (dataContext.debugMode && feedbacks.length && claims.length) {
                console.warn('Yes No feedbacks amount mismatch (claims: ' + claims.length + ', feedbacks: ' + feedbacks.length +' )');
            }

            return false;
        }).extend({rateLimit: 0});

        self.getFeedbackContent = function(index, type) {
            var feedbacks = self.feedbacks();

            return (feedbacks && feedbacks[index] && feedbacks[index].hasOwnProperty(type)) ? feedbacks[index][type] : '';
        }

        self.isAnswered = ko.computed(function() {
            return (self.enableFeedbacks() && !trainingVM.answersEnabled());
        });

        self.updateAnswer = function(ID, value) {
            var box, inner, val = '',
                status = '',
                input = document.getElementById(ID),
                buttons = document.querySelectorAll('[data-button="' + ID + '"]'),
                nodes = document.querySelectorAll('.f-col-button-saved-checked');

            if (!trainingVM.answersEnabled() || !input || input && input.value) {
                return;
            }

            if (input && value) {
                input.value = value;
            }

            for (var n = 0; n < nodes.length; n++) {
                nodes[n].classList.remove('f-col-button-saved-checked');
            }

            for (var i = 0; i < buttons.length; i++) {
                val = (buttons[i].dataset && buttons[i].dataset.value) ? buttons[i].dataset.value : '';

                buttons[i].classList.remove('f-col-active');

                if (trainingVM.hasCorrectAnswers()) {
                    status = (val && trainingVM.isYesNoAnswerCorrect(ID, val)) ? 'correct' : 'incorrect';
                } else {
                    status = 'answered';
                }

                status += (val === value) ? '-checked': '';

                buttons[i].className += ' f-col-button-' + status;
            }

            trainingVM.validate();

            if (self.enableFeedbacks()) {
                box = document.getElementById('box-' + ID);

                if (box) {
                    box.className += ' box-answered';
                    inner = box.querySelector('.box-inner');
                }

                if (inner) {
                    if (trainingVM.hasCorrectAnswers()) {
                        status = (value && trainingVM.isYesNoAnswerCorrect(ID, value)) ? 'correct' : 'incorrect';
                    } else {
                        status = 'answered';
                    }

                    inner.classList.add('box-inner-' + status);

                    if (!Modernizr.csstransitions && typeof window.TimelineMax === 'function') {
                        var tl = new window.TimelineMax(),
                            f = box.querySelector('.box-front'),
                            b = box.querySelector('.box-back');

                        tl.to(f, 0.22, {scaleX:0.0});
                        tl.to(b, 0.22, {scaleX:1.0}, '+=0.22');
                    }
                }


                if (trainingVM.isValid()) {
                    setTimeout(function() {
                        trainingVM.submitForm();
                    }, 450);
                }

            } else {
                if (trainingVM.isValid()) {
                    trainingVM.submitForm();
                }
            }


        };
    }
});


